import React from 'react';

/**
 * Placeholder card while a leaderboard section loads.
 *
 * @param {Object} props
 * @param {number} [props.rowCount=5]
 * @param {string} [props.className]
 */
export function LeaderboardSectionSkeleton({ rowCount = 5, className = '' }) {
  return (
    <div
      className={`bg-surface rounded-xl shadow-sm border border-border p-3 sm:p-6 animate-pulse ${className}`}
      aria-hidden="true"
    >
      <div className="h-6 w-48 bg-border-light rounded mb-4" />
      <div className="space-y-2 sm:space-y-3">
        {Array.from({ length: rowCount }, (_, i) => (
          <div
            key={i}
            className="flex items-center gap-3 rounded-full px-4 py-3 bg-surface-subtle border border-border-light"
          >
            <div className="h-10 w-10 rounded-full bg-border-light shrink-0" />
            <div className="flex-1 space-y-2">
              <div className="h-4 w-32 bg-border-light rounded" />
              <div className="h-3 w-16 bg-border-light rounded" />
            </div>
            <div className="h-4 w-12 bg-border-light rounded" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default LeaderboardSectionSkeleton;
